import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import 'assets/scss/confirmation-modal.css';

const ConfirmationModal = ({ isVisible, toggleModal, children }) => {
  return (
    <Modal className="confirmation-modal" visible={isVisible}>
      <div className="modal-header">
        <a
          onClick={e => {
            e.preventDefault();
            toggleModal();
          }}
          className="close-onboarding-modal"
        >
          <FontAwesomeIcon icon="times" />
        </a>
      </div>
      <div className="modal-body text-center">{children}</div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleRemoveConfirmationModal: PropTypes.func,
};

export default withRouter(ConfirmationModal);



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/Modal/index.js